import type { BoatChargeItemSectionDto, CreateBoatChargeItemSectionDto, UpdateBoatChargeItemSectionDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { DataRequestDto, EntitySchemaDto, IdNameDto, PageRequestDto } from '../models';

@Injectable({
  providedIn: 'root',
})
export class BoatChargeItemSectionService {
  apiName = 'Default';
  

  create = (input: CreateBoatChargeItemSectionDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, BoatChargeItemSectionDto>({
      method: 'POST',
      url: '/api/app/boat-charge-item-section',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/app/boat-charge-item-section/${id}`,
    },
    { apiName: this.apiName,...config });
  

  get = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, BoatChargeItemSectionDto>({
      method: 'GET',
      url: `/api/app/boat-charge-item-section/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getCount = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, number>({
      method: 'GET',
      url: '/api/app/boat-charge-item-section/count',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getDropDownOptions = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<IdNameDto>>({
      method: 'GET',
      url: '/api/app/boat-charge-item-section/drop-down-options',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getExpandById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, BoatChargeItemSectionDto[]>({
      method: 'GET',
      url: `/api/app/boat-charge-item-section/${id}/expand`,
    },
    { apiName: this.apiName,...config });
  

  getExtraPropertiesById = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Record<string, object>>({
      method: 'GET',
      url: `/api/app/boat-charge-item-section/${id}/extra-properties`,
    },
    { apiName: this.apiName,...config });
  

  getIds = (input: DataRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, string[]>({
      method: 'GET',
      url: '/api/app/boat-charge-item-section/ids',
      params: { select: input.select, filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getList = (input: PageRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<BoatChargeItemSectionDto>>({
      method: 'GET',
      url: '/api/app/boat-charge-item-section',
      params: { filter: input.filter, onlyActive: input.onlyActive, additionalData: input.additionalData, ignoreMaxResultCount: input.ignoreMaxResultCount, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getOneExtraPropertiesByIdAndKey = (id: string, key: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, object>({
      method: 'GET',
      url: `/api/app/boat-charge-item-section/${id}/one-extra-properties`,
      params: { key },
    },
    { apiName: this.apiName,...config });
  

  getSchema = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, EntitySchemaDto>({
      method: 'GET',
      url: '/api/app/boat-charge-item-section/schema',
    },
    { apiName: this.apiName,...config });
  

  getWithDetails = (id: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, BoatChargeItemSectionDto>({
      method: 'GET',
      url: `/api/app/boat-charge-item-section/${id}/with-details`,
    },
    { apiName: this.apiName,...config });
  

  setExtraPropertiesByIdAndKeyAndValue = (id: string, key: string, value: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: `/api/app/boat-charge-item-section/${id}/set-extra-properties`,
      params: { key, value },
    },
    { apiName: this.apiName,...config });
  

  update = (id: string, input: UpdateBoatChargeItemSectionDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, BoatChargeItemSectionDto>({
      method: 'PUT',
      url: `/api/app/boat-charge-item-section/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
